export default __webpack_public_path__ + "static/media/compare.7be97579.svg";